import axios from 'axios';
import authHeader from "@/services/auth-header";
import ConstApiUrls from "@/services/const-api-urls";

const API_URL = ConstApiUrls.API_SERVICE_URL

class FTemplateRegService {
    getApiUrl() {
        return API_URL
    }
    getAllFTemplateReg(){
        return axios.get(API_URL + `getAllFTemplateReg`, { headers: authHeader() });
    }
    getAllFTemplateRegPublic(){
        return axios.get(API_URL + `public/getAllFTemplateReg`, { headers: authHeader() });
    }

    getAllFTemplateRegByCompany(){
        return axios.get(API_URL + `getAllFTemplateRegByCompany`, { headers: authHeader() });
    }

    getAllFTemplateRegContaining(page, pageSize, sortBy, order, search){
        // return axios.get(API_URL + `getAllFTemplateReg`, { headers: authHeaderMultipart() });
        return axios.get(API_URL + `getAllFTemplateRegContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}`, { headers: authHeader() });
    }
    getFTemplateRegById(id){
        return axios.get(API_URL + `getFTemplateRegById/${id}`, { headers: authHeader() });
    }
    getFTemplateRegByIdPublic(id){
        return axios.get(API_URL + `public/getFTemplateRegById/${id}`, { headers: authHeader() });
    }


    updateFTemplateReg(item){
        return axios.put(API_URL + `updateFTemplateReg/${item.id}`, item, {headers: authHeader()})
    }
    createFTemplateReg(item){
        return axios.post(API_URL + `createFTemplateReg`, item, {headers: authHeader()})
    }
    deleteFTemplateReg(id){
        return axios.delete(API_URL + `deleteFTemplateReg/${id}`, {
            headers: authHeader()
        });
    }
    deleteAllFTemplateReg(itemIds){
        return axios.delete(API_URL + `deleteAllFTemplateReg`, {
            headers:  authHeader(),
            data: itemIds
        });


    }
}
export default new FTemplateRegService()